import request from '@/utils/request'
/**
* @fileOverview 地址管理
*/

/**
* @description 地址列表
*/
export function address(id, params) {
  return request({
    url: id ? `/address/${id}` : '/address',
    method: 'get',
    params
  })
}

/**
  * @description 创建地址
  * @param {string} data.email 个人信息电子邮件
  * @param {string} data.firstname 名
  * @param {string} data.lastname 姓
  * @param {string} data.form 性别
  * @param {string} data.title 头衔
  * @param {string} data.position 职位
  * @param {string} data.phone 手机号
  * @param {string} data.company_name 单位名称
  * @param {string} data.company_ename 单位名称英文
  * @param {string} data.street 地址
  * @param {string} data.zip 邮政编码
  * @param {string} data.city 城市
  * @param {string} data.country 国家
  * @param {string} data.homepage 主页网址
  * @param {string} data.address_phone 工作电话
  * @param {string} data.address_email 邮箱
  * @param {string} data.address_fax 传真
  */
export function createAddress(data) {
  return request({
    url: '/address',
    method: 'post',
    data
  })
}

/**
  * @description 编辑地址
  * @param {string} data.email 个人信息电子邮件
  * @param {string} data.firstname 名
  * @param {string} data.lastname 姓
  * @param {string} data.form 性别
  * @param {string} data.title 头衔
  * @param {string} data.position 职位
  * @param {string} data.phone 手机号
  * @param {string} data.company_name 单位名称
  * @param {string} data.company_ename 单位名称英文
  * @param {string} data.street 地址
  * @param {string} data.zip 邮政编码
  * @param {string} data.city 城市
  * @param {string} data.country 国家
  * @param {string} data.homepage 主页网址
  * @param {string} data.address_phone 工作电话
  * @param {string} data.address_email 邮箱
  * @param {string} data.address_fax 传真
  */
export function editAddress(id, data) {
  return request({
    url: `/address/${id}`,
    method: 'put',
    data
  })
}

/**
  * @description 编辑地址
  * @param {string} user_id 个人信息电子邮件
  */
export function addressGetDesignInfo(user_id) {
  return request({
    url: `/address/getDesignInfo/${user_id}`,
    method: 'get'
  })
}
